import { ComponentProps } from "react";
import { DeviceSelector } from "../components/DeviceSelector";

const selectAriaLabel = "micCamCheck:device.camera.selection.accessibility";

const CameraSelector = (
  props: ComponentProps<typeof DeviceSelector>,
): JSX.Element => (
  <DeviceSelector {...props} selectAriaLabel={selectAriaLabel} />
);

export default CameraSelector;
